import PropTypes from 'prop-types';
import React from 'react';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {ContentTypesFilter} from '@utils/commonFilters/ContentTypesFilter';
import {ContentVariantsFilter} from '@utils/commonFilters/ContentVariantsFilter';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {DeviceCategoriesFilter} from '@utils/commonFilters/DeviceCategoriesFilter';
import {DistributionTypesFilter} from '@utils/commonFilters/DistributionTypesFilter';
import {HqFilter} from '@utils/commonFilters/HqFilter';
import {LlFilter} from '@utils/commonFilters/LlFilter';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {BookingTypesFilter} from '@utils/commonFilters/BookingTypesFilter';
import {CancellationStatusFilter} from '@utils/commonFilters/CancellationStatusFilter';
import {ClientsFilter} from '@utils/commonFilters/ClientsFilter';
import {EventContentsFilter} from '@utils/commonFilters/EventContentsFilter';
import {InvoiceStatusesFilter} from '@utils/commonFilters/InvoiceStatusesFilter';

export const EventsBookingsComponent = (props) => {
    const {
            products,
            distributionTypes,
            deviceCategories,
            bookingTypes,
            clients,
            countries,
            eventContents,
            invoiceStatuses,
            eventContentTypes,
            eventContentVariants,
        } = props.data,
        loading = props.loading;

    return (
        <div className='eventBookings__filters filter__controls__container'>
            <ClientsFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
                options={clients}
            />
            <EventContentsFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
                options={eventContents}
            />
            <ContentTypesFilter
                eventContentTypes={eventContentTypes}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ContentVariantsFilter
                eventContentVariants={eventContentVariants}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ProductsFilter
                loading={loading}
                products={products}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <DistributionTypesFilter
                distributionTypes={distributionTypes}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <DeviceCategoriesFilter
                deviceCategories={deviceCategories}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <HqFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <LlFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <BookingTypesFilter
                bookingTypes={bookingTypes}
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
            <InvoiceStatusesFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
                invoiceStatuses={invoiceStatuses}
            />
            <CancellationStatusFilter
                loading={loading}
                filters={props.filters.EventsBookings}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

EventsBookingsComponent.propTypes = {
    data: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(EventsBookingsComponent, {
    name: 'EventsBookings',
    initialValues: {
        isCancelled: 0,
    },
});
